import React from "react";
import { HelpCircle } from "react-feather";
import "./Form.scss";

const NumericInput = (props) => {
  if (props.label === "wtstate") {
    return <></>;
  }
  return (
    <div className="form-group">
      <label className="form-label">{props.label}</label>
      <div className={`input-wrapper`}>
        <input
          id={props.name}
          name={props.name}
          className={`form-input`}
          value={props.value ? props.value : ""}
          type={props.type ? props.type : "number"}
          min={props.min}
          max={props.max}
          maxLength={props.maxLength.toString()}
          onChange={props.onChange}
          autoComplete="off"
          step={props.step ? props.step : ""}
          disabled={props.disabled ? props.disabled : false}
          {...props}
        />
        {props.unit && <span className="form-unit">{`[${props.unit}]`}</span>}
      </div>
      <a
        className="help-icon-link"
        href={props.help}
        target="_blank"
        rel="noopener noreferrer"
      >
        <HelpCircle
          color="rgba(0, 0, 0, 0.75)"
          strokeWidth="2"
          size="26px"
          style={{
            alignSelf: "center",
            paddingLeft: "4px",
          }}
        />
      </a>
    </div>
  );
};

const NumericResultsInput = (props) => {
  return (
    <div style={{ justifyContent: "space-between" }} className="form-group">
      <label style={{ width: "auto" }} className="form-label">
        {props.label}
      </label>
      <div
        className={`input-wrapper`}
        style={
          props.disabled
            ? { backgroundColor: "#e7e7e7", width: "250px" }
            : { width: "250px" }
        }
      >
        <input
          id={props.name}
          name={props.name}
          className={`form-input`}
          value={props.value ? props.value : ""}
          //defaultValue={props.defaultValue}
          type={props.type ? props.type : "number"}
          onChange={props.onChange}
          autoComplete="off"
          step={props.step ? props.step : ""}
          onBlur={props.onBlur}
          disabled={props.disabled ? props.disabled : false}
          {...props}
        />
      </div>
    </div>
  );
};

export { NumericInput, NumericResultsInput };
